import { createContext } from 'react';

const localidadContext = createContext();

export default localidadContext;